import { Button, ITabsProps, Popover, Tab, Tabs } from "@blueprintjs/core";
import React from "react";
import styled from "styled-components";
import ScrollArea from "react-scrollbar"
import { IconNames } from "@blueprintjs/icons";
import ConfigEditor from "./ConfigEditor";
import LabelList from "./label/LabelList";
import LayoutTree from "./LayoutTree";
import PanelList from "./panels/PanelList";
import PropertyEditor from "./properties/PropertyEditor";
import { LeftScrollbars } from "./styled/fragments";
import ViewList from "./views/ViewList";


/**
 * main menu for site editing.
 */

// TODO add the scrollbars in this container instead of making the tab header fixed.
const StyledTabs = styled(Tabs)`

	.bp3-tab-list {
    	box-shadow: 0px 0px 12px -1px rgba(0,0,0,0.6);
		padding: 15px 30px;
		background: rgb(26,30,32);
		height: 60px;
		display: flex;
		align-items: center;
	}

	.bp3-tab-panel {
		margin: 0;
	}

	.edit-scroll {
		height: calc(100vh - 60px) !important;
	}

	.edit-panel {
		padding: 20px;
	}

` as any;

const wrapPanel = (panel) => (
	<ScrollArea
		className="area edit-scroll"
		smoothScrolling={true}
		speed={0.8}
        >
			<div className="edit-panel">
				{panel}
			</div>
    </ScrollArea>
);

export default () => (
	<StyledTabs>
		<Tab
			id="layouts"
			title="Layout"
			panel={wrapPanel(<LayoutTree />)}
		/>

		<Tab
			id="panels"
			title="Panels"
			panel={wrapPanel(<PanelList />)}
		/>

		<Tab
			id="views"
			title="Views"
			panel={wrapPanel(<ViewList />)}
		/>

		<Tab
			id="properties"
			title="Properties"
			panel={wrapPanel(<PropertyEditor openTarget={PropertyEditor.TARGET_CHILD} />)}
		/>

		{/*<LabelList useDialog={true} />

		<Popover content={<ConfigEditor style={{margin: "10px"}}/>}>
			<Button icon={IconNames.CODE} minimal={true} />
		</Popover>*/}
	</StyledTabs>
);



// WEBPACK FOOTER //
// ./src/core/components/editor/EditMenu.tsx